import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { DropDownData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<DropDownData>;
};

export const DropDownModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
